import React from 'react';

import { TpDashboardElement, TpDashboardContext, TpDashboardHorizontalLayoutDefinition } from '../dashboard/interfaces';
import { TpDataContext } from '../../../data/interfaces';
import { renderDashboardElement } from '../dashboard/render-elem';
import { dashboardWidgetPadding } from '../dashboard/layout-hints';
import { useAppDispatch } from '../../../app/hooks';
import { ElementEditTools } from '../dashboard/edit-mode/ElementEditTools';

interface TpDashboardHorizontalLayoutProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpDashboardHorizontalLayoutDefinition;
}

function DashboardHorizontalLayout({
  dataContext,
  parentElemDef,
  elemDef,
  dashboardContext,
}: TpDashboardHorizontalLayoutProps) {
  const dispatch = useAppDispatch();

  const getChildRelSize = (child: TpDashboardElement) => {
    return ('elemLayoutHints' in child ? child.elemLayoutHints?.sizeXRelative : undefined) || 1;
  };

  let totalRelSize = 0;
  for (const child of elemDef.elements) {
    totalRelSize += getChildRelSize(child);
  }
  totalRelSize = Math.max(1, totalRelSize);
  const totalPadding = elemDef.elements.length * dashboardWidgetPadding;

  const spacer = (
    <div style={{ display: 'inline-block', backgroundColor: 'transparent', width: `${dashboardWidgetPadding}px` }} />
  );

  const width = dashboardContext.editMode ? 'calc(100% - 60px)' : '100%';

  const style: any = { width: '100%', whiteSpace: 'nowrap', minHeight: '100px', position: 'relative' };
  if (dashboardContext.editMode) {
    style.border = '1px dashed rgb(255,128,0)';
    style.boxSizing = 'border-box';
  }
  return (
    <div style={style}>
      <div style={{ width, height: '100%', display: 'inline-block' }}>
        {elemDef.elements.map((el, idx) => (
          <React.Fragment key={`idx_${idx}`}>
            <div
              style={{
                width: `calc(${(getChildRelSize(el) / totalRelSize) * 100}% - ${
                  totalPadding / elemDef.elements.length
                }px)`,
                height: '100%',
                display: 'inline-block',
                whiteSpace: 'normal',
                verticalAlign: 'top',
              }}
            >
              {renderDashboardElement(elemDef, el, dataContext, dashboardContext)}
            </div>
            {idx < elemDef.elements.length - 1 && spacer}
          </React.Fragment>
        ))}
        {dashboardContext.editMode && (
          <ElementEditTools
            dataContext={dataContext}
            dashboardContext={dashboardContext}
            parentElemDef={parentElemDef}
            elemDef={elemDef}
            dispatch={dispatch}
          />
        )}
      </div>
    </div>
  );
}

export default DashboardHorizontalLayout;
